import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=96f38488&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96f38488"]])

export default __exports__